<template>
    <div>
        <show-knowledge-mes :query='query'></show-knowledge-mes>
    </div>
</template>

<script>
import showKnowledgeMes from '../common/showKnowledgeMes'

export default {

    components: { showKnowledgeMes },

    props: {
        detail: Object
    },
    
    computed: {
        query(){
            return this.detail.title
        }
    }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>